import { useQuery } from '@apollo/client';
import { PublicApiKeyItem } from '@provision/entity-types';
import { useMemo } from 'react';
import { GET_PUBLIC_API_KEYS_QUERY } from 'src/graphql/entities/public-api-key/public-api-key.operations';
import { useGlobalStore } from 'src/store';
import { useNotifications } from 'src/utils/hooks';
import { omitTypename } from 'src/utils/omit-typename';

export interface GetPublicApiKeysQuery {
  getPublicApiKeys: PublicApiKeyItem[];
}

export interface GetPublicApiKeysVariables {
  partnerId: number;
  includeDisabled?: boolean;
}

export const usePublicApiKeys = (options: { includeDisabled?: boolean } = {}) => {
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();
  const { showErrorAlert } = useNotifications();

  const { data, loading, refetch } = useQuery<
    GetPublicApiKeysQuery,
    GetPublicApiKeysVariables
  >(GET_PUBLIC_API_KEYS_QUERY, {
    variables: {
      partnerId: selectedPartnerId!,
      includeDisabled: options.includeDisabled ?? true,
    },
    skip: !selectedPartnerId,
    fetchPolicy: 'cache-and-network',
    onError: (error) => {
      console.error(error);
      showErrorAlert('Failed to load API keys, please try again');
    },
  });

  const apiKeys = useMemo(() => omitTypename(data?.getPublicApiKeys ?? []), [data?.getPublicApiKeys]);

  return {
    apiKeys,
    isLoading: loading,
    refetch,
  };
};
